// Indicative registrar pricing (USD/yr) for the 3-way comparison.
// Ezi Webb figures come from eziwebb.com domain-only rates; the other two are
// approximate reference values. Prices are indicative — the registrar confirms
// the final price at checkout. Format per TLD: [firstYear, renewal].

const PRICES = {
  com: { eziwebb: [15.0, 15.0], namecheap: [9.98, 15.98], godaddy: [11.99, 21.99] },
  net: { eziwebb: [15.5, 15.5], namecheap: [12.98, 14.98], godaddy: [21.99, 24.99] },
  org: { eziwebb: [16.0, 16.0], namecheap: [9.98, 15.98], godaddy: [9.99, 22.99] },
  io: { eziwebb: [39.0, 39.0], namecheap: [32.98, 44.98], godaddy: [44.99, 64.99] },
  co: { eziwebb: [36.0, 36.0], namecheap: [8.98, 33.98], godaddy: [12.99, 34.99] },
  ai: { eziwebb: [79.0, 79.0], namecheap: [64.98, 84.98], godaddy: [79.99, 99.99] },
  app: { eziwebb: [16.0, 16.0], namecheap: [14.98, 18.98], godaddy: [19.99, 22.99] },
  dev: { eziwebb: [15.0, 15.0], namecheap: [12.98, 16.98], godaddy: [17.99, 21.99] },
  xyz: { eziwebb: [17.0, 17.0], namecheap: [1.98, 13.98], godaddy: [1.99, 14.99] },
  me: { eziwebb: [24.5, 24.5], namecheap: [8.98, 22.98], godaddy: [11.99, 24.99] },
  info: { eziwebb: [26.5, 26.5], namecheap: [3.98, 24.98], godaddy: [4.99, 26.99] },
  tech: { eziwebb: [58.5, 58.5], namecheap: [4.98, 49.98], godaddy: [5.99, 54.99] },
  online: { eziwebb: [36.0, 36.0], namecheap: [2.98, 39.98], godaddy: [4.99, 44.99] },
  site: { eziwebb: [35.0, 35.0], namecheap: [2.98, 34.98], godaddy: [4.99, 39.99] },
  store: { eziwebb: [51.0, 51.0], namecheap: [4.98, 59.98], godaddy: [9.99, 64.99] },
  live: { eziwebb: [27.0, 27.0], namecheap: [3.98, 27.98], godaddy: [4.99, 29.99] },
  studio: { eziwebb: [27.0, 27.0], namecheap: [13.98, 29.98], godaddy: [19.99, 32.99] },
  world: { eziwebb: [40.0, 40.0], namecheap: [2.98, 39.98], godaddy: [4.99, 42.99] },
  space: { eziwebb: [31.5, 31.5], namecheap: [2.98, 29.98], godaddy: [3.99, 32.99] },
  fun: { eziwebb: [38.0, 38.0], namecheap: [4.98, 38.98], godaddy: [5.99, 39.99] },
  sh: { eziwebb: [39.0, 39.0], namecheap: [34.98, 44.98], godaddy: [39.99, 49.99] },
  tv: { eziwebb: [35.5, 35.5], namecheap: [29.98, 39.98], godaddy: [34.99, 44.99] },
};

const DEFAULT = {
  eziwebb: [24.99, 24.99],
  namecheap: [19.98, 29.98],
  godaddy: [21.99, 29.99],
};

// Always includes Ezi Webb; kept to exactly 3 to stay clean on mobile.
const REGISTRARS = [
  {
    key: "eziwebb",
    name: "Ezi Webb",
    url: () =>
      process.env.REACT_APP_REGISTER_URL ||
      "https://eziwebb.com/sole-domains-registration-4/",
  },
  {
    key: "namecheap",
    name: "Namecheap",
    url: (d) => `https://www.namecheap.com/domains/registration/results/?domain=${d}`,
  },
  {
    key: "godaddy",
    name: "GoDaddy",
    url: (d) => `https://www.godaddy.com/domainsearch/find?domainToCheck=${d}`,
  },
];

// Lowest ongoing renewal across the 3 registrars — used for price sorting.
export function getSortPrice(tld) {
  const p = PRICES[tld] || DEFAULT;
  return Math.min(p.eziwebb[1], p.namecheap[1], p.godaddy[1]);
}

export function getPriceComparison(tld, domain) {
  const p = PRICES[tld] || DEFAULT;
  const rows = REGISTRARS.map((r) => ({
    key: r.key,
    name: r.name,
    url: r.url(domain),
    first: p[r.key][0],
    renew: p[r.key][1],
  }));
  // "Best value" = lowest ongoing renewal rate (what you keep paying).
  const minRenew = Math.min(...rows.map((r) => r.renew));
  rows.forEach((r) => {
    r.bestValue = r.renew === minRenew;
  });
  return rows;
}
